import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { MainLayout } from './components/layout';

// Pages - lazy loaded
const Dashboard = React.lazy(() => import('./app/Dashboard'));
const PositionList = React.lazy(() => import('./app/positions/PositionList'));
const PositionDetail = React.lazy(() => import('./app/positions/PositionDetail'));
const MonthlyDecision = React.lazy(() => import('./app/positions/MonthlyDecision'));
const WeeklyDecision = React.lazy(() => import('./app/positions/WeeklyDecision'));
const DailyGuard = React.lazy(() => import('./app/positions/DailyGuard'));
const TradeHistory = React.lazy(() => import('./app/positions/TradeHistory'));
const History = React.lazy(() => import('./app/History'));
const Settings = React.lazy(() => import('./app/Settings'));

function PageLoader() {
  return (
    <div className="flex h-64 items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
        <p className="text-sm text-muted-foreground">加载中...</p>
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <React.Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<MainLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="positions" element={<PositionList />} />
            <Route path="positions/:id" element={<PositionDetail />} />
            <Route path="positions/:id/decision/monthly" element={<MonthlyDecision />} />
            <Route path="positions/:id/decision/weekly" element={<WeeklyDecision />} />
            <Route path="positions/:id/decision/daily" element={<DailyGuard />} />
            <Route path="positions/:id/trades" element={<TradeHistory />} />
            <Route path="history" element={<History />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
      </React.Suspense>
    </BrowserRouter>
  );
}

export default App;
